export default "__VITE_ASSET__Ckl3ASLN__"